<template>
   <div class="actions_block shadow-lg">
         <div class="icon_block ">
               <a href="tel:0692 67 76 85" class="flex flex-col items-center justify-center text-white">
              <span class="logo-contact block text-sm">
                     <svg class="fill-current text-white hover:text-orange-300 inline-block h-8 w-8 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                        <path class="cls-1" d="M35.47,23.81h-.16a1,1,0,0,1-.79-1.1,7.34,7.34,0,0,0-.22-3.22,7.65,7.65,0,0,0-1.91-3.21,5.67,5.67,0,0,0-3.1-1.65,4.41,4.41,0,0,0-2,.12,1,1,0,1,1-.55-1.84,6.44,6.44,0,0,1,2.83-.18,7.66,7.66,0,0,1,4.16,2.19,9.49,9.49,0,0,1,2.39,4A9.16,9.16,0,0,1,36.41,23,1,1,0,0,1,35.47,23.81Z"/>
                        <path class="cls-1" d="M41.37,26.7a1,1,0,0,1-.29-.05,1,1,0,0,1-.62-1.21,13.29,13.29,0,0,0,0-8.34,13.88,13.88,0,0,0-3.12-5.27,12.37,12.37,0,0,0-5-3.24,10.89,10.89,0,0,0-6.75,0A1,1,0,1,1,25,6.78a12.75,12.75,0,0,1,7.94,0,14.39,14.39,0,0,1,5.82,3.73,16,16,0,0,1,3.56,6,15.29,15.29,0,0,1,0,9.53A1,1,0,0,1,41.37,26.7Z"/>
                        <path class="cls-1" d="M25.18,34c-2.5,0-5.49-1.72-7.74-4.65-3-3.93-3.56-8.57-1.29-10.78a1,1,0,0,1,1.36,0,1,1,0,0,1,0,1.35C16,21.44,16.62,25.14,19,28.19s5.74,4.65,7.57,3.56a1,1,0,1,1,1,1.65A4.5,4.5,0,0,1,25.18,34Z"/>
                        <path class="cls-1" d="M29.05,43.85c-4.11,0-10.24-4.33-15.66-11.4-6.66-8.7-9-17.45-5.51-20.36,2-1.64,2.28-1.79,2.69-1.83a1,1,0,0,1,1,.87,1,1,0,0,1-.67,1A23.18,23.18,0,0,0,9.1,13.57c-2.29,1.9-.5,9.46,5.82,17.72s13.19,12,15.58,10.23c1.35-1,1.78-1.35,1.9-1.47A1,1,0,0,1,34,41.1c-.15.26-.33.46-2.36,2A4.27,4.27,0,0,1,29.05,43.85Z"/>
                        <path class="cls-1" d="M34.64,40.81h-.26A2,2,0,0,1,33.07,40h0l-5.94-7.75a2,2,0,0,1,.37-2.77l2.69-2.06a2,2,0,0,1,2.77.36l5.94,7.75a2,2,0,0,1-.37,2.78l-2.69,2.06A2,2,0,0,1,34.64,40.81Zm0-1.94s0,0,0,0l2.73-2.08L31.44,29,28.66,31Z"/>
                        <path class="cls-1" d="M18.68,20l-.26,0a2,2,0,0,1-1.31-.76l-5.94-7.74a2,2,0,0,1,.37-2.78l2.69-2.06A2,2,0,0,1,17,7l5.94,7.75a2,2,0,0,1-.37,2.77l-2.69,2.06A1.94,1.94,0,0,1,18.68,20ZM15.48,8.17l-2.77,2.05,5.92,7.83h0l0,0L21.4,16Z"/>
                     </svg>  
              </span>
              <span class="">Tél</span>
            </a> 
         </div>
         <div class="icon_block ">
            <a href="#devis" @click.prevent="$parent.openContactModal()" class="flex flex-col items-center justify-center text-white">
               <span class="logo-devis block text-sm">
                     <svg class="fill-current text-white  inline-block h-8 w-8 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                        <path class="cls-1" d="M24,26.68a1,1,0,0,1-.91-1.25l1.38-4.35a.92.92,0,0,1,.23-.39L40.09,5.29a1,1,0,0,1,1.36,0l3,3a1,1,0,0,1,0,1.35L29,25a1,1,0,0,1-.39.24l-4.35,1.38A.92.92,0,0,1,24,26.68Zm2.23-4.79-.75,2.36,2.36-.75L42.38,8.93,40.77,7.32Z"/><path class="cls-1" d="M41.33,12.34a.94.94,0,0,1-.68-.28l-3-3A1,1,0,0,1,39,7.73l3,3a1,1,0,0,1,0,1.36A1,1,0,0,1,41.33,12.34Z"/><path class="cls-1" d="M37.47,38.67H13.19a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1H36.66a1,1,0,1,1,0,1.92H14.15V36.75H36.51V16a1,1,0,0,1,1.92,0V37.71A1,1,0,0,1,37.47,38.67Z"/><path class="cls-1" d="M29.44,17.44H17.35a1,1,0,0,1,0-1.92H29.44a1,1,0,1,1,0,1.92Z"/><path class="cls-1" d="M25.36,22.12h-8a1,1,0,0,1,0-1.92h8a1,1,0,0,1,0,1.92Z"/><path class="cls-1" d="M23.69,26.81H17.35a1,1,0,1,1,0-1.92h6.34a1,1,0,1,1,0,1.92Z"/>
                     </svg>  
               </span>
               <span class="">Devis</span>
            </a> 
         </div>
         <div class="icon_block   ">
             <a href="#share" @click.prevent="$parent.openShareModal()" class="flex flex-col items-center justify-center text-white">
               <span class="logo-share block text-sm">
                    <svg class="fill-current text-white hover:text-orange-300 inline-block h-6 w-6 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                        <path class="cls-1" d="M37.17,31.19a6.55,6.55,0,0,0-5.54,3.08L19.79,28.34a6.37,6.37,0,0,0,.49-2.47,6.6,6.6,0,0,0-.7-2.94L31,16.06a6.53,6.53,0,1,0-1.22-3.79,6.43,6.43,0,0,0,.7,2.93l-11.4,6.88a6.54,6.54,0,1,0,.28,7.15l11.82,5.93a6.54,6.54,0,1,0,6-4Z"/>
                     </svg> 
               </span>
               <span class="">Partager</span>
            </a> 
         </div>
   </div>
</template>

<script>
export default {
   name:'actions'
   
}
</script>

<style scoped>
.actions_block{
   @apply flex fixed z-20 bg-orange-100 z-20 bottom-0 w-full py-1;
}

.actions_block .icon_block{
   @apply w-1/3 flex items-center justify-center;
}

@media (min-width: 1024px) {
  .actions_block{
      @apply w-auto block right-0 py-3;
      bottom: 50%;
      transform: translateY(50%) skew(0deg, -10deg); 
   }
  .actions_block .icon_block{
      @apply w-auto px-2 py-3;
      transform: skew(0deg, 10deg); 
   }
}
</style>